import {
  EXPERIENCE_TYPES,
  VENUE,
  WizardStep,
} from '@app/routes/create-event-wizard/domain';

export const eventcreationWizardPath = '/create-event-wizard';

const descriptionStep: WizardStep = {
  path: '/description',
  label: 'Description',
  key: 'description',
};

const eventAreasStep: WizardStep = {
  path: '/event-areas',
  label: 'Event Areas',
  key: 'event-areas',
};

export const TEMPLATES: {
  [key in (typeof EXPERIENCE_TYPES)[keyof typeof EXPERIENCE_TYPES]]: {
    autoPublish?: boolean;
    steps: WizardStep[];
    defaultVenue: VENUE;
    defaultAddOns: {
      [key: string]: {
        selected: boolean;
      };
    };
  };
} = {
  webinar_experience: {
    autoPublish: true,
    steps: [
      {
        ...descriptionStep,
        canSkip: true,
      },
    ],
    defaultVenue: {
      reception: { selected: false },
      stage: { selected: false },
      sessions: { selected: true },
      networking: { selected: false },
      expo: { selected: false },
    },
    defaultAddOns: {
      chat: { selected: true },
      q_and_a: { selected: true },
      polls: { selected: false },
      speakers: { selected: false },
      sponsors: { selected: false },
    },
  },
  virtual_experience: {
    steps: [
      {
        ...eventAreasStep,
        canSkip: true,
      },
      {
        ...descriptionStep,
        canSkip: true,
      },
    ],
    defaultVenue: {
      reception: {
        selected: true,
      },
      stage: {
        selected: true,
      },
      sessions: {
        selected: true,
      },
      networking: {
        selected: true,
      },
      expo: {
        selected: true,
      },
    },
    defaultAddOns: {
      sponsors: {
        selected: true,
      },
      speakers: {
        selected: true,
      },
      q_and_a: {
        selected: true,
      },
      polls: {
        selected: true,
      },
      chat: {
        selected: true,
      },
    },
  },
  hybrid_experience: {
    steps: [
      {
        ...eventAreasStep,
        canSkip: true,
      },
      {
        ...descriptionStep,
        canSkip: true,
      },
    ],
    defaultVenue: {
      reception: {
        selected: true,
      },
      stage: {
        selected: true,
      },
      sessions: {
        selected: true,
      },
      networking: {
        selected: true,
      },
      expo: {
        selected: true,
      },
    },
    defaultAddOns: {
      sponsors: {
        selected: true,
      },
      speakers: {
        selected: true,
      },
      q_and_a: {
        selected: true,
      },
      polls: {
        selected: true,
      },
      chat: {
        selected: true,
      },
    },
  },
  onsite_experience: {
    steps: [
      {
        ...descriptionStep,
        canSkip: true,
      },
    ],
    defaultVenue: {
      reception: {
        selected: true,
      },
      stage: {
        selected: false,
      },
      sessions: {
        selected: true,
      },
      expo: {
        selected: true,
      },
      networking: {
        selected: false,
      },
    },
    defaultAddOns: {
      sponsors: {
        selected: true,
      },
      speakers: {
        selected: true,
      },
      q_and_a: {
        selected: false,
      },
      polls: {
        selected: false,
      },
      chat: {
        selected: false,
      },
    },
  },
};
